import { Link } from 'gatsby'
import React, { useState, useEffect, ReactElement } from 'react'
import { Container, Navbar, Nav, Row, Col } from 'react-bootstrap'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import useQueryProperty from '@hooks/useQueryProperty'
import { getFakeAddress } from '@helpers/helper.developments'
import { RealEstateDataPageComponentData } from 'types'
import { navigate } from 'gatsby'

const isBrowser = typeof window !== 'undefined'

const Supra_NavBar_2 = ({
  developmentID,
  propertyID,
  global_data,
  subtitle,
  button,
}: {
  developmentID: string
  propertyID: string
} & RealEstateDataPageComponentData) => {
  const { divisionPath } = global_data
  const [scrollTop, setScrollTop] = useState<number>(0)
  const [isScrolled, setIsScrolled] = useState(false)

  const { data: allDevelopmentData, isLoading: isLoadingDevelopments } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )

  const { data: allPropertyData, isLoading: isLoadingProperties } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )

  useEffect(() => {
    const onScroll = (e: any) => {
      setScrollTop(e.target.documentElement.scrollTop)
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [scrollTop])

  // // Scroll effect
  // useEffect(() => {
  //   if (allDevelopmentData || allPropertyData?.development) {
  //     setTimeout(function () {
  //       if (isBrowser) {
  //         const header = document.querySelector('#dynamic_header_2') as HTMLElement
  //         const content = document.querySelector('dynamic_header') as HTMLElement
  //         if (header?.clientHeight > 0) {
  //           content.style.paddingTop = header?.clientHeight + 'px'
  //         } else {
  //           content.style.paddingTop = '0px'
  //         }
  //         // window.addEventListener('scroll', function () {
  //         //   const header = document.querySelector('#dynamic_header_2') as HTMLElement
  //         //   let content = document.querySelector('body') as HTMLElement
  //         //   if (window.scrollY > 0) {
  //         //     setIsScrolled(true)
  //         //     // content.style.paddingTop = header?.clientHeight + 'px'
  //         //   } else {
  //         //     setIsScrolled(false)
  //         //     // content.style.paddingTop = header?.clientHeight + 'px'
  //         //   }
  //         // })
  //       }
  //     }, 100)
  //   }
  // }, [allDevelopmentData, allPropertyData])

  function getURL(): string {
    document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
    return (
      (divisionPath ?? '') +
      (allDevelopmentData
        ? '/emprendimientos/'
        : allPropertyData?.development
        ? '/emprendimiento/' +
          allPropertyData?.development.name?.toLowerCase() +
          '/' +
          allPropertyData?.development?.id
        : '/')
    ) // TODO: Hardcoding the dynamic path?
  }

  // Nav element
  const NavEl = (desktop: boolean = true): ReactElement => (
    <>
      <Nav
        className={`me-lg-3 nav-menu ${
          desktop ? 'd-flex justify-content-between w-auto' : 'd-flex flex-column w-100'
        }`}
      >
        <Nav.Item>
          <Link
            to={getURL()}
            className="nav-link return-dev"
          >
            Volver a{' '}
            {allDevelopmentData
              ? 'Emprendimientos'.toLowerCase()
              : allPropertyData?.development
              ? allPropertyData.development.name.length > 20
                ? allPropertyData.development.name.substring(0, 20) + '...'
                : allPropertyData.development.name
              : 'Inicio'.toLowerCase()}{' '}
          </Link>
        </Nav.Item>
      </Nav>
    </>
  )

  const capitalizeFirstLetter = (text: string): string => {
    return text?.substring(0, 1)?.toUpperCase() + text?.toLowerCase()?.substring(1, text?.length)
  }

  return !allPropertyData?.development && !allDevelopmentData ? null : (
    <header
      id="dynamic_header_2"
      className={`${isLoadingDevelopments || isLoadingProperties ? ' skeleton ' : ''} b ${
        isScrolled ? 'position-fixed' : 'position-fixed'
      }`}
    >
      <Navbar
        sticky="top"
        className="brand"
      >
        <Container
          fluid
          className="d-flex flex-column flex-lg-row"
        >
          <Row className="justify-content-center align-items-center w-100 position-relative">
            {subtitle && (
              <p
                className="d-none d-lg-block position-absolute top-text"
                aria-label={subtitle}
              >
                {subtitle}
              </p>
            )}
            <Col className="px-0 text-right d-flex justify-content-end col-menu">{NavEl()}</Col>
          </Row>
        </Container>
      </Navbar>
      {/* <div className="bg-nabvar"></div> */}
    </header>
  )
}

export default Supra_NavBar_2
